<div class="url-wrapper">
  <a
    href="https://play.google.com/store/apps/details?id=com.paymentsmanagerplus.app&pli=1"
    target="_blank"
  >
    <span style="display: none">Google Play</span>
    <img
      role="img"
      class="background-image-link"
      src="assets/images/auth/google-play-badge.svg"
      alt="Google Play"
    />
  </a>
</div>
